import { useMediaQuery } from "@mui/material";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import parse from "html-react-parser";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Color from "../../../assets/colors";
import { DividerStyled, SectionContainer, TextStyled } from "../styles";
import {
  DescriptionBody,
  DescriptionCard,
  DescriptionColumnDivider,
  DescriptionContainer,
  DescriptionWrapper,
  useStyles,
} from "./styles";

function CompanyDescription(props) {
  const { companyDetail, companySocial, setCurrentTab } = props || {};

  const isMobile = useMediaQuery("(max-width: 640px)");
  const { t } = useTranslation();

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    rootMargin: "-200px 0px -60% 0px",
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      setCurrentTab(2);
    }
  }, [entry?.isIntersecting, setCurrentTab]);

  const socialCount = companySocial?.length;
  const descriptionCount = companyDetail?.length || 0;
  const showDesktopDivider = !isMobile && descriptionCount === 2;

  const classes = useStyles();

  return (
    <SectionContainer
      aria-label={t("companydetail.description_section_aria")}
      id="CompanyAbout"
      className={classes.scrollBar}
      ref={ref}
    >
      <DescriptionCard>
        <TextStyled
          variant={"h2"}
          color={"#000"}
          fontSize={"20px"}
          fontWeight={700}
          lineHeight={"30px"}
          textTransform={"none"}
          margin={"0 0 1.5rem"}
          aria-label={t("companydetail.description_section_title_aria")}
        >
          {t("companydetail.our_story")}
        </TextStyled>
        <DescriptionWrapper
          $companySocial={socialCount}
          $descriptionCount={descriptionCount}
        >
          {companyDetail?.map((desc, index) => {
            return (
              <Fragment key={index}>
                {index === 1 && isMobile ? (
                  <DividerStyled sx={{ margin: "0 0 1rem" }} />
                ) : null}
                {index === 1 && showDesktopDivider ? (
                  <DescriptionColumnDivider />
                ) : null}
                <DescriptionContainer
                  $companySocial={socialCount}
                  $descriptionCount={descriptionCount}
                >
                  <TextStyled
                    color={Color.hiredlyPurple}
                    variant={"h3"}
                    fontSize={"13px"}
                    fontWeight={700}
                    textTransform={"uppercase"}
                    lineHeight={"19.5px"}
                    letterSpacing={"0.8px"}
                    margin={"0 0 0.875rem"}
                    aria-label={t("companydetail.description_title_aria")}
                  >
                    {desc.title}
                  </TextStyled>
                  <DescriptionBody
                    aria-label={t("companydetail.description_body_aria")}
                  >
                    {parse(desc.body)}
                  </DescriptionBody>
                </DescriptionContainer>
              </Fragment>
            );
          })}
        </DescriptionWrapper>
      </DescriptionCard>
    </SectionContainer>
  );
}

export default CompanyDescription;
